module.exports = __webpack_public_path__ + "media/images/wishlist-1-925d33bd22ee0710b6a3049567904793.svg";